// user info cache
// https://firebase.google.com/docs/analytics/ios/webview
// 2018.08.29 Wildmud Aleiku
import CONFIG from '../config';
import http from './http';

export default new class UserInfo {
	constructor() {
	    this.pullData()
	}
	pullData(callback = (code=100, data={}, reason='發生錯誤') => {}){
		http.get(CONFIG.API_HOST + 'api/v1.3/config', 
		  {}
		  , 
		  (state, res) => {
		    
		    const {code=100, reason='發生錯誤', data={} } = res;
		    console.log('userinfo', state, res)
		    if (state === false) { return callback(code, {}, reason) }

		    if (code !== 200)    { return callback(code, {}, reason) }

		    const { user={} } = data;
			
		    Object.assign(this, user);
		    
		    callback(code, this, reason)
		})
	}

}()


// WEBPACK FOOTER //
// ./src/helpers/userinfo.js